import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { OrgVaultsPage } from "@/features/vault/components/org-vaults-page";

/**
 * Vaults de ORGANIZACIÓN (zero-knowledge multi-usuario). Tras la compuerta:
 * abrir la clave del vault exige la clave privada del usuario en memoria.
 */
function OrgVaultsRoutePage() {
  return (
    <VaultGate>
      <OrgVaultsPage />
    </VaultGate>
  );
}

export const orgVaultsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/org-vaults",
  component: OrgVaultsRoutePage,
});
